import { useSeo } from "../hooks/useSeo";
import { PageHeader } from "../components/PageHeader";
import { StaggerGroup, StaggerItem, Reveal } from "../components/Reveal";
import { PillButton } from "../components/PillButton";
import { AREE, AREE_INTRO } from "../data/content";
import { AreeInterventoSection } from "../components/AreeInterventoSection";
import { ArrowRight, Users } from "lucide-react";

export default function Aree() {
  useSeo(
    "Percorsi ed interventi — Psicologa e Psicoterapeuta a Macerata",
    "Consulenza psicologica, psicoterapia individuale e cognitivo-comportamentale, terapia EMDR, valutazione psicologica e neuropsicologica a Macerata.",
    "/aree-di-intervento"
  );

  return (
    <>
      <PageHeader
        eyebrow="Percorsi ed interventi"
        title="Competenze al servizio della persona"
        subtitle="Ogni descrizione è informativa e non sostituisce un colloquio. Contatta lo studio per verificare se un percorso è adatto alle tue esigenze."
      />

      <section className="py-16 md:py-24" data-testid="aree-list">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <div className="mb-12 flex items-center gap-4 bg-sand border border-border rounded-2xl px-6 py-5" data-testid="aree-intro-note">
              <Users size={22} className="text-sage-dark shrink-0" />
              <p className="text-ink text-base md:text-lg">{AREE_INTRO}</p>
            </div>
          </Reveal>

          <StaggerGroup className="grid gap-px bg-border rounded-2xl overflow-hidden border border-border">
            {AREE.map((a) => (
              <StaggerItem key={a.n}>
                <article className="group bg-cream p-8 md:p-10 grid md:grid-cols-12 gap-4 md:gap-8 items-start transition-colors duration-300 hover:bg-sand">
                  <div className="md:col-span-2">
                    <span className="font-serif text-5xl md:text-6xl text-sage">{a.n}</span>
                  </div>
                  <div className="md:col-span-4">
                    <h2 className="font-serif text-2xl md:text-3xl text-ink leading-snug">{a.title}</h2>
                  </div>
                  <div className="md:col-span-6">
                    <p className="text-stone leading-relaxed">{a.desc}</p>
                  </div>
                </article>
              </StaggerItem>
            ))}
          </StaggerGroup>

          <Reveal>
            <div className="mt-16 bg-sand border border-border rounded-2xl p-8 md:p-12 flex flex-col md:flex-row md:items-center justify-between gap-6">
              <div>
                <h3 className="font-serif text-3xl md:text-4xl text-ink">Non sei sicuro/a di quale percorso scegliere?</h3>
                <p className="text-stone mt-3 max-w-xl leading-relaxed">
                  Il modo migliore per capirlo è parlarne. Scrivimi due righe sul motivo del contatto e valuteremo insieme.
                </p>
              </div>
              <PillButton to="/contatti" testid="aree-cta">
                Richiedi informazioni <ArrowRight size={18} />
              </PillButton>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Sezione Aree di Intervento (raggiungibile scorrendo o dalla tendina) */}
      <div className="border-t border-border/60">
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 md:pt-28">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.28em] text-sage-dark mb-6">Aree di Intervento</p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-serif text-4xl md:text-6xl text-ink tracking-tight leading-tight max-w-3xl">
              Le difficoltà che affrontiamo insieme
            </h2>
          </Reveal>
          <Reveal delay={0.14}>
            <p className="mt-6 text-lg text-stone leading-relaxed max-w-2xl">
              Le principali aree in cui offro percorsi di psicoterapia. Ogni situazione è unica: contatta lo studio
              per valutare insieme il percorso più adatto.
            </p>
          </Reveal>
        </div>
      </div>
      <AreeInterventoSection id="aree-intervento" />
    </>
  );
}
